import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { ISizeName } from '@df/core/service/client';
import { StylesService } from '@df/core/service/styles';
import { ImageModule } from '@df/module-image/image.module';
import { DfCmsModal } from '@df/ui/modal/df-cms-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { ModalLayoutRightComponent, NModalLayoutRight } from '../../../ui/modal/modal-layout-right.component';

export namespace NCmsPdpTrustMessagesModal {
    export const BLOCK_ID = 'pdp-trust-messages-modal';
    export interface IBlockData extends Catalog.IBlockData<IBlockDataContent> {}
    export interface IBlockDataContent {
        title: string;
        image: string;
        descriptionTitle?: string;
        description?: string;
    }
}
@DfCmsModal({
    id: NCmsPdpTrustMessagesModal.BLOCK_ID,
    name: 'Pdp Trust Messages',
    position: (sizeId: ISizeName) => {
        return sizeId === 'S' ? 'bottom' : 'right';
    },
    config: sizeName => ({
        ...NModalLayoutRight.ModalConfig,
        width: NModalLayoutRight.getWidth(sizeName),
        position: sizeName === 'S' ? { bottom: '0' } : NModalLayoutRight.ModalConfig.position,
        height: { S: StylesService.vh(90), M: StylesService.vh(100), L: StylesService.vh(100), X: StylesService.vh(100) }[sizeName]
    }),
    reopenPolicy: NDfModal.ReopenPolicy.first,
    prerenderAllowed: false,
    sizeRestriction: ['S', 'M', 'L', 'X']
})
@ICmsComponent<PdpTrustMessagesModalComponent>({
    id: NCmsPdpTrustMessagesModal.BLOCK_ID,
    block: {
        url: NCmsPdpTrustMessagesModal.BLOCK_ID
    },
    onDemandOnly: true,
    name: 'Pdp Trust Messages',
    description: 'Pdp Trust Messages Content',
    fields: [
        <NICmsContentField.IField>{
            key: 'image',
            type: NICmsContentField.EFieldType.image,
            title: 'Image',
            required: true
        },
        <NICmsContentField.IField>{
            key: 'title',
            type: NICmsContentField.EFieldType.text,
            title: 'Title',
            required: true
        },
        <NICmsContentField.IField>{
            key: 'descriptionTitle',
            type: NICmsContentField.EFieldType.text,
            title: 'Description Title'
        },
        <NICmsContentField.IField>{
            key: 'description',
            type: NICmsContentField.EFieldType.text,
            title: 'Description'
        }
    ]
})
@Component({
    selector: 'pdp-trust-messages-modal',
    templateUrl: './pdp-trust-messages-modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ImageModule, ModalLayoutRightComponent, CommonModule, ICmsClientModule]
})
export class PdpTrustMessagesModalComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: NCmsPdpTrustMessagesModal.IBlockDataContent;
}
